import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'moment-duration-format';
import 'scrollingelement';
import 'transitionEnd';
import {loadableReady} from '@loadable/component';
import isNil from 'lodash/isNil';
import React from 'react';
import {hydrate} from 'react-dom';
import {Provider} from 'react-redux';
import {Router} from 'react-router-dom';
import {renderRoutes} from 'react-router-config';
import APIUtils from '@spothero/utils/api';
import createStore, {getHistory} from 'store/store';
import routes from 'router/routes';
import SegmentUtils from 'utils/segment';
import startup from './startup';

const appData = window.__INITIAL_DATA__; // eslint-disable-line no-underscore-dangle
const {
    configData,
    initialState,
    destination,
    pageType,
    optimizelyDatafile,
    optimizelyCookies,
    ttfrTimer,
} = appData;
const {
    searchRequest: {isSearchPage, starts},
    user: {data: user},
} = initialState;

APIUtils.init({
    baseUrl: configData.spotHeroAPIBasePath,
    additionalHeaders: {
        Authorization: null,
        'Content-Type': 'application/x-www-form-urlencoded',
        'SpotHero-Version': '2019-08-13',
    },
});

if (isSearchPage && !isNil(starts)) {
    // every search page that has a map would also have a starts date set, whereas pages like airport search that is a landing page wouldnt have starts set
    SegmentUtils.startTimeToFirstResultTimer({
        isInitialLoad: true,
        timerAddition: ttfrTimer,
    });
}

const render = async () => {
    await startup({
        configData,
        isBrowser: true,
        optimizelyData: optimizelyDatafile,
        serverCookies: optimizelyCookies,
        pageType,
        destination,
        user,
    });

    loadableReady(() => {
        hydrate(
            <Provider store={createStore(initialState)}>
                <Router history={getHistory()}>
                    {renderRoutes(routes, appData)}
                </Router>
            </Provider>,
            document.querySelector('.root')
        );
    });

    delete window.__INITIAL_DATA__; // eslint-disable-line no-underscore-dangle
};

render();
